(() => {
  'use strict';
  if (window.ucwPrinterPageInitialized) return;
  window.ucwPrinterPageInitialized = true;
  const init = root => {
    const store = window.UCWPrinters;
    if (!store || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const el = key => root.querySelector(`[data-printer-${key}]`);
    const node = (tag, className, text) => {
      const result = document.createElement(tag);
      if (className) result.className = className;
      if (text) result.textContent = text;
      return result;
    };
    const collectionUrl = handle => `${window.Shopify?.routes?.root || '/'}collections/${encodeURIComponent(handle)}`;
    const records = new Map(), requests = new Set();
    let busy = false, signature = '', selected = '', generation = 0;
    const status = text => { el('status').textContent = text; el('status').hidden = !text; };
    const setBusy = value => {
      busy = value;
      root.setAttribute('aria-busy', String(value));
      root.querySelectorAll('button[data-printer-action]').forEach(button => { button.disabled = value; });
    };
    async function action(operation, success) {
      if (busy) return;
      setBusy(true); status('Uw wijziging wordt verwerkt…');
      try { await operation(); if (success) status(success); }
      catch (error) { status(store.message(error)); }
      finally { setBusy(false); }
    }
    function button(label, handler, primary = false) {
      const result = node('button', `ucw-printer-account__${primary ? 'primary' : 'secondary'}`, label);
      result.type = 'button'; result.dataset.printerAction = '';
      result.addEventListener('click', handler);
      return result;
    }
    function picture() {
      const media = node('span', 'ucw-printer-account__image');
      media.setAttribute('aria-hidden', 'true');
      media.innerHTML = '<svg viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 17V6h22v11M13 35H7V18h34v17h-6M13 28h22v14H13zM33 23h3"/></svg>';
      return media;
    }
    function updateMetadata(record, data) {
      const name = typeof data.title === 'string' && data.title.trim() ? data.title : record.printer.name;
      record.name = name; record.titles.forEach(title => { title.textContent = name; });
      record.choose.setAttribute('aria-label', `Producten voor ${name} bekijken`);
      record.remove.setAttribute('aria-label', `${name} verwijderen uit uw printers`);
      if (typeof data.featured_image !== 'string') return;
      let url; try { url = new URL(data.featured_image, location.origin); } catch { return; }
      if (url.protocol !== 'https:') return;
      record.media.forEach(media => {
        const img = node('img'); img.width = 120; img.height = 90; img.alt = ''; img.loading = 'eager'; img.decoding = 'async';
        img.addEventListener('load', () => media.replaceChildren(img), { once: true }); img.src = url.href;
      });
    }
    async function loadMetadata(items, epoch) {
      let index = 0;
      const worker = async () => {
        while (index < items.length && epoch === generation) {
          const record = items[index++], controller = new AbortController(); requests.add(controller);
          const timer = setTimeout(() => controller.abort(), 10000);
          try {
            const response = await fetch(`${collectionUrl(record.printer.handle)}?view=ucw-meta`, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) continue;
            const data = await response.json();
            if (epoch === generation && record.choose.isConnected && data.handle === record.printer.handle) updateMetadata(record, data);
          } catch {} finally { clearTimeout(timer); requests.delete(controller); }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, items.length) }, worker));
    }
    async function loadProducts(record, append = false) {
      if (record.loading) return;
      record.loading = true;
      const container = record.products, epoch = generation, controller = new AbortController();
      requests.add(controller); container.setAttribute('aria-busy', 'true');
      record.productsMessage.hidden = false; record.productsMessage.textContent = 'Geschikte producten worden geladen…'; record.more.disabled = true;
      const url = new URL(append ? record.next : collectionUrl(record.printer.handle), location.origin);
      url.searchParams.set('section_id', 'uw-opgeslagen-printers-products');
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        if (url.origin !== location.origin) throw new Error();
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error();
        const html = await response.text();
        if (generation !== epoch || !container.isConnected) return;
        const doc = new DOMParser().parseFromString(html, 'text/html'), content = doc.querySelector('[data-printer-products-result]');
        if (!content) throw new Error();
        content.querySelectorAll('script').forEach(script => script.remove());
        const next = content.querySelector('[data-printer-products-next]'), nextUrl = next?.getAttribute('href') || ''; next?.remove();
        if (append) {
          const grid = container.querySelector('.uw-main-collection__grid'); if (!grid) throw new Error();
          grid.append(...content.querySelectorAll('.uw-main-collection__grid > li'));
        } else container.replaceChildren(content);
        record.next = nextUrl; record.loaded = true; record.more.hidden = !nextUrl;
        record.productsMessage.hidden = true; record.retry.hidden = true;
        document.dispatchEvent(new CustomEvent('uw:products-loaded', { detail: { container } }));
      } catch {
        if (generation !== epoch || !container.isConnected) return;
        record.productsMessage.textContent = 'De producten konden niet worden geladen. Probeer het opnieuw.';
        record.retry.hidden = false; record.retryAppend = append;
      } finally { clearTimeout(timer); requests.delete(controller); record.loading = false; container.removeAttribute('aria-busy'); record.more.disabled = false; }
    }
    function select(id) {
      selected = id;
      records.forEach((record, key) => {
        const active = key === id; record.choose.setAttribute('aria-pressed', String(active)); record.panel.hidden = !active;
        if (active && !record.loaded) loadProducts(record);
      });
    }
    function createRecord(printer, index) {
      const record = { printer, name: printer.name, loaded: false, loading: false, next: '' };
      const item = node('li');
      record.choose = button('', () => select(printer.id)); record.choose.className = 'ucw-printer-account__choose'; record.choose.id = `ucw-printers-choice-${index}`;
      const navTitle = node('strong', '', printer.name), smallImage = picture();
      record.choose.append(smallImage, navTitle, node('span', 'ucw-printer-account__arrow', '›')); item.append(record.choose); el('list').append(item);
      record.panel = node('section', 'ucw-printer-account__panel'); record.panel.hidden = true; record.panel.id = `ucw-printers-products-${index}`;
      record.choose.setAttribute('aria-controls', record.panel.id);
      const header = node('header', 'ucw-printer-account__panel-header'), largeImage = picture(), titleGroup = node('div', 'ucw-printer-account__title-group');
      const title = node('h2', '', printer.name); title.id = `${record.panel.id}-title`; record.panel.setAttribute('aria-labelledby', title.id);
      titleGroup.append(node('p', 'ucw-printer-account__eyebrow', 'Producten voor uw printer'), title);
      const actions = node('div', 'ucw-printer-account__actions');
      record.remove = button('Printer verwijderen', () => action(() => store.remove(printer.id), 'Uw printer is verwijderd.'));
      actions.append(record.remove); header.append(largeImage, titleGroup);
      record.products = node('div', 'ucw-printer-account__products');
      record.productsMessage = node('p', 'ucw-printer-account__products-status'); record.productsMessage.setAttribute('role', 'status');
      record.more = button('Meer geschikte producten tonen', () => loadProducts(record, true)); record.more.hidden = true;
      record.retry = button('Producten opnieuw laden', () => loadProducts(record, record.retryAppend)); record.retry.hidden = true;
      record.panel.append(header, actions, record.products, record.productsMessage, record.retry, record.more); el('panels').append(record.panel);
      record.titles = [navTitle, title]; record.media = [smallImage, largeImage]; updateMetadata(record, {});
      return record;
    }
    function clear() { generation++; requests.forEach(controller => controller.abort()); records.clear(); el('list').replaceChildren(); el('panels').replaceChildren(); }
    function render() {
      const state = store.snapshot();
      root.classList.toggle('is-loading', ['loading', 'redirecting'].includes(state.status));
      el('refresh').hidden = state.status !== 'ready';
      el('content').hidden = state.status !== 'ready'; el('login').hidden = state.status !== 'signed-out'; el('retry').hidden = state.status !== 'error';
      if (['loading', 'redirecting'].includes(state.status)) { status(state.status === 'redirecting' ? 'Uw printer is opgeslagen. De geschikte producten worden geopend…' : 'Uw printergegevens worden geladen…'); return; }
      if (state.status !== 'ready') {
        if (records.size) clear(); signature = ''; selected = '';
        status(state.error || (state.status === 'signed-out' ? '' : 'Uw printers kunnen tijdelijk niet worden geladen.')); return;
      }
      const nextSignature = JSON.stringify(state.printers);
      if (signature !== nextSignature) {
        clear(); signature = nextSignature;
        state.printers.forEach((printer, index) => { records.set(printer.id, createRecord(printer, index)); });
        if (!records.has(selected)) selected = state.printers[0]?.id || '';
        select(selected); loadMetadata([...records.values()], generation);
      }
      el('empty').hidden = state.printers.length !== 0; el('workspace').hidden = !state.printers.length;
      el('count').textContent = String(state.printers.length); status(''); setBusy(busy);
    }
    el('login-button').addEventListener('click', () => action(() => store.login()));
    el('refresh').addEventListener('click', () => action(async () => { const result = await store.refresh(); if (result.status !== 'ready' || result.error) throw new Error('account_error'); }, 'Uw printers zijn bijgewerkt.'));
    el('retry').addEventListener('click', () => action(() => store.refresh()));
    const lifecycle = new AbortController();
    document.addEventListener('ucw:printers-updated', render, { signal: lifecycle.signal });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { clear(); lifecycle.abort(); } }, { signal: lifecycle.signal });
    store.ready.then(render); render();
  };
  const scan = (root = document) => root.querySelectorAll('[data-ucw-printer-account]').forEach(init);
  scan(); document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
